// ===========================================
// PhotoPreviewModal.js
// 童顏家行程日曆系統 - 照片預覽彈窗元件
//
// 版本：V1.01 | 2024-07-05 20:10:00
// 主要功能：簡易照片預覽、放大縮小、拖拽查看
// 解決問題：讓用戶快速預覽照片內容
//
// 版本紀錄：
// - V1.01 (2024-07-05): 初始版本，從 App.js 拆分
//
// 注意事項：
// - 僅負責預覽，不含詳細資訊與下載
// - 關聯檔案：App.js
// ===========================================
import React, { useState } from 'react';

const PhotoPreviewModal = ({ config, onClose }) => {
    const { isOpen, photo } = config || {};
    const [scale, setScale] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    if (!isOpen) return null;
    if (!isOpen || !photo) return null;
    const handleZoom = (newScale) => {
        setScale(Math.max(0.5, Math.min(3, newScale)));
        if (newScale <= 1) {
            setPosition({ x: 0, y: 0 });
        }
    };
    const handleMouseDown = (e) => {
        if (scale > 1) {
            setIsDragging(true);
            setDragStart({
                x: e.clientX - position.x,
                y: e.clientY - position.y
            });
        }
    };
    const handleMouseMove = (e) => {
        if (isDragging && scale > 1) {
            setPosition({
                x: e.clientX - dragStart.x,
                y: e.clientY - dragStart.y
            });
        }
    };
    const handleMouseUp = () => {
        setIsDragging(false);
    };
    const resetZoom = () => {
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };
    return (
        <div className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center p-4 z-[95]" onClick={onClose}>
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-4xl max-h-[95vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()}>
                <div className="flex justify-between items-center p-4 border-b flex-shrink-0">
                    <h3 className="text-xl font-bold text-gray-900">📸 照片預覽</h3>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
                            <button onClick={() => handleZoom(scale - 0.5)} className="px-2 py-1 text-sm bg-white rounded hover:bg-gray-50" disabled={scale <= 0.5}>🔍-</button>
                            <span className="text-sm px-2">{Math.round(scale * 100)}%</span>
                            <button onClick={() => handleZoom(scale + 0.5)} className="px-2 py-1 text-sm bg-white rounded hover:bg-gray-50" disabled={scale >= 3}>🔍+</button>
                            <button onClick={resetZoom} className="px-2 py-1 text-sm bg-white rounded hover:bg-gray-50">🔄</button>
                        </div>
                        <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-2xl">&times;</button>
                    </div>
                </div>
                <div className="flex-1 p-4 flex items-center justify-center bg-gray-100 overflow-hidden">
                    <div className="relative overflow-hidden rounded-lg" onMouseDown={handleMouseDown} onMouseMove={handleMouseMove} onMouseUp={handleMouseUp} onMouseLeave={handleMouseUp} style={{ cursor: scale > 1 ? 'grab' : 'default' }}>
                        <img src={photo.photoDataUrl} alt="夥伴拍攝的照片" className="max-w-full max-h-full object-contain transition-transform duration-200" style={{ transform: `scale(${scale}) translate(${position.x / scale}px, ${position.y / scale}px)`, transformOrigin: 'center' }} draggable={false} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhotoPreviewModal; 